import api from '../services/ApiService';

/*
  This deals with collections as in collecting of payments.
  Specifically for the customer, not to be confused by form collections
  in data input.
*/
export const GET_COLLECTIONS = 'GET_COLLECTIONS';
export const CREATE_COLLECTIONS = 'CREATE_COLLECTIONS';

export function getCollections(key, branchId) {

  const query = branchId !== undefined ? `?branchId=${branchId}` : '';

  return {
    type: GET_COLLECTIONS,
    payload: api.get(`/collections/${key}${query}`),
  };
}

export function createCollections(collection) {
  return {
    type: CREATE_COLLECTIONS,
    payload: api.post('/collections', collection),
  };
}
